import { UserUMS } from "../../../types/Users";

export const formatUsers = (users: UserUMS[]): UserUMS[] => {
  const results: UserUMS[] = [];
  users.forEach((user) => {
    results.push({
      ...user,
      // Having undefined values mixed in with the boolean messes up the sorting, so we force it to be either true or false
      archived: user.archived ? true : false,
    });
  });
  return results;
};

export const validateUsername = (username: string): string | undefined => {
  if (username.trim() === "") return "";

  if (!/^[a-z0-9@._-]*$/.test(username)) {
    return "Usernames may only contain lowercase letters, numbers, -, _, @, and .";
  }

  // First character must be alphanumeric
  if (!/^[a-z0-9]/.test(username)) {
    return "Usernames must start with a lowercase letter or number";
  }

  return undefined;
};
